export const URL_API = 'https://ssl14.porta80.com.br/prosaudece_ws/';
export const username = "usrSite";
export const password = "#*$#59&65#548JgeFgff#";

export const sessionId = "prosaude";
